import { render, staticRenderFns } from "./custom-form-alliance.vue?vue&type=template&id=25e2314f&scoped=true&"
import script from "./custom-form-alliance.vue?vue&type=script&lang=js&"
export * from "./custom-form-alliance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e2314f",
  null
  
)

export default component.exports